/**
 * Gallery prototype definition
 *
 * @public
 * @param {Element} context Gallery context Element
 * @param {String[]} images Images URLs
 */

galleryInit = function (context, images) {
    "use strict";

    var gallery = this,
        passive = {
            passive: true
        },


        /*** Methods ***/

        /**
         * Sets a value to an Attribute of an Element
         * 
         * @private
         * @param {Element} elm Element
         * @param {String} attr Attribute's name
         * @param {String} value Value to set
         */
        setAttr = function(elm, attr, value) {
            elm.setAttribute(attr, value);
        },

        /**
         * Gets an Attribute value from an Element
         * 
         * @private
         * @param {Element} elm Element
         * @param {String} attr Attribute's name
         * @return {Any} Attribute's value
         */
        getAttr = function(elm, attr) {
            return elm.getAttribute(attr);
        },

        /**
         * Removes the value of an Element's Attribute
         * 
         * @private
         * @param {Element} elm Element
         * @param {String} attr Attribute's name
         */
        removeAttr = function(elm, attr) {
            elm.removeAttribute(attr);
        },

        /**
         * Checks if a given element contains a class
         * 
         * @private
         * @param {Element} elm Element
         * @param {String} className Class name to find
         * @return {Boolean} Result
         */
        hasClass = function(elm, className) {
            return elm.classList.contains(className);
        },

        /**
         * Inserts an Element relative to another using a given position
         * 
         * @private
         * @param {Element} nElm Element to insert
         * @param {String} pos Position to use
         * @param {Element} ref Reference Element
         */
        insertAt = function(nElm, pos, ref) {
            ref.insertAdjacentElement(pos, nElm);
        },


        /**
         * Adds a Event Listener to an Element
         * 
         * @private
         * @param {Element | Element[]} elm Element
         * @param {String} eventName Event's name
         * @param {Function} fn Function to execute each time the event is triggered
         * @param {any} options Add Event Listener method available options (See Mozilla Developers Documentation for more info.)
         */
        addEvent = function(elm, eventName, fn, options) {
            if (!Array.isArray(elm)) {
                elm.addEventListener(eventName, fn, options);
                return;
            }

            for (var i = 0; i < elm.length; ++i) {
                elm[i].addEventListener(eventName, fn, options);
            }
        },

        /**
         * Gets the Touch object from a TouchEvent object
         * 
         * @private
         * @param {TouchEvent} event TouchEvent
         * @return {Touch} Touch
         */
        getTouch = function(event) {
            return event.touches[0] || event.changedTouches[0];
        },

        /**
         * Gets the Id of a Touch
         * 
         * @private
         * @param {Touch} touch Touch
         * @return {Number} Id
         */
        getTouchId = function(touch) {
            return touch.identifier;
        },

        /**
         * Gets the Touch's X value
         * 
         * @private
         * @param {Touch} touch Touch
         * @return {Number} X value
         */
        getTouchX = function(touch) {
            return touch.screenX;
        },

        /**
         * Sets an X value to an Image
         * 
         * @private
         * @param {Image} img Image
         * @param {Number} x X value
         */
        setImgX = function(img, x) {
            img.style.transform = "translateX(" + x + "px) translateY(-50%)";
        },

        /**
         * Gets the X value of an Image
         * 
         * @private
         * @param {Image} img Image
         * @return {Number} X value
         */
        getImgX = function(img) {
            if (img.style.transform) {
                var match = img.style.transform.match(/-?\d+/);
                return match[0] ? parseFloat(match[0]) : 0;
            }
            return 0;
        },


        /**
         * Gets the undefined literal value
         * 
         * @private
         * @return {undefined} undefined
         */
        getUndefined = function() {
            return void 0;
        },

        /**
         * Checks if a given variable is undefined
         * 
         * @private
         * @param {Any} variable Variable to check
         * @return {Boolean} Result
         */
        isUndefined = function(variable) {
            return variable === getUndefined();
        },

        /**
         * Sets the animation time of an Image
         * 
         * @private
         * @param {Image} img Image
         * @param {String} attr Attribute to animate
         * @param {Number} seconds Time in seconds
         */
        setAnimationTime = function(img, attr, seconds) {
            img.style.transition = attr + " " + seconds + "s";
        },

        /**
         * Sets the X movement animation time of the Gallery images
         * 
         * @private
         * @param {Number} seconds Time in Seconds         
         */
        setXAnimationTime = function(seconds) {
            setAnimationTime(context.querySelector(".previous"), "transform", seconds);
            setAnimationTime(context.querySelector(".active"), "transform", seconds);
            setAnimationTime(context.querySelector(".next"), "transform", seconds);
        },

        /**
         * Checks if the given image element is instance of the native Image prototype
         *
         * @param  {Image | HTMLDivElement} img Image Element
         * @return {Boolean} Result
         */
        isImage = function(img) {
            return (img instanceof Image);
        },

        /**
         * Gets the associated image of an image
         *
         * @param {Image | HTMLDivElement} imgElm Image Element
         * @return {Image | HTMLDivElement} Associated Image
         */
        getAssociatedImage = function(imgElm) {
            return imgElm[(isImage(imgElm) ? "" : "regular") + "Image"];
        },

        /**
         * Check is the Gallery image in the index
         * is of the needed type in order to change it
         * 
         * @private
         * @param {Image | HTMLDivElement} imgElm Image Element
         * @param {Number} index Gallery Index to check
         * @return {Image | HTMLDivElement} Image Element
         */
        tryToggleImageType = function(imgElm, index) {
            var image = gallery.images[index];
            if (isImage(imgElm)) {
                return imgElm;
            } else {
                var newImage = getAssociatedImage(imgElm);
                imgElm.parentNode.replaceChild(newImage, imgElm);
                return newImage;
            }
        },

        /**
         * Sets the source to a regular Image
         * 
         * @private
         * @param {Image | HTMLDivElement} imgElm Image Element
         * @param {String} src Source
         */
        setSrc = function(imgElm, src) {
            if (imgElm && src) {
                setAttr(imgElm, (isImage(imgElm) ? "" : "data-") + "src", src);
            }
        },

        /**
         * Sets the sourceset to a regular Image 
         * 
         * @private
         * @param {Image | HTMLDivElement} imgElm Image Element
         * @param {String} srcset Source set
         */
        setSrcset = function (imgElm, srcset) {
            if (imgElm && srcset) {
                setAttr(imgElm, (isImage(imgElm) ? "" : "data-") + "srcset", srcset);
            }
        },

        /**
         * Sets the size to a regular Image 
         * 
         * @private
         * @param {Image | HTMLDivElement} imgElm Image Element
         * @param {String} srcset Source set
         */
        setSizes = function (imgElm, sizes) {
            if (imgElm && sizes) {
                setAttr(imgElm, "sizes", sizes);
            }
        },

        setPosition = function (imgElm, position) {
            if (imgElm && position) {
                setAttr(imgElm, "data-position", position);
            }
        },

        setCollection = function (imgElm, collection) {
            if (imgElm && collection) {
                setAttr(imgElm, "data-collection", collection);
            }
        },

        setImgId = function (imgElm, id) {
          if (imgElm && id) {
            setAttr(imgElm, "data-image-id", id);
          }
        },

        /**
         * Sets the alternative text or title to a regular Image
         * 
         * @private
         * @param {Image | HTMLDivElement} imgElm Image Element
         * @param {String} alt Alt text
         */
        setAlt = function(imgElm, alt) {
            if (imgElm && alt) {
                setAttr(imgElm, (isImage(imgElm) ? "alt" : "title"), alt);
            }
        },


        /**
         * If the image to show its a floor plan, we apply a class that fits it in the given container | BDXNHS-3125
         * 
         * @private
        
         * @param {Boolean} isNext if the user clicked the right arrow > in the home detail
         * @param {Number} imageIndex represents the index of the next image to show in the image array
         * @param {HTMLImageElement} nextImg represents the next image in the gallery 
         */
        setFloorPlanClass = function (isNext, imageIndex, nextImg) {
            var isPortraitImage = nextImg.naturalHeight > nextImg.naturalWidth;
            var selector = isNext ? ".next" : ".previous";
            var imagesArray = gallery.images;
            var newActiveImage = document.querySelector("#gallery " + selector);

            if (!newActiveImage) return;

            if (imagesArray[imageIndex].isFloorPlan && !newActiveImage.classList.contains("nhs_floorPlanFit") || isPortraitImage) {
                newActiveImage.classList.add("nhs-c-image--vertical");
            }

        },

 
        /**
         * Moves the Gallery to the Next image
         * 
         * @private
         * @param {Image | HTMLDivElement} prevImg Previous Image
         * @param {Image | HTMLDivElement} activeImg Active Image         
         * @param {Image | HTMLDivElement} nextImg Next Image
         */
        goNext = function(prevImg, activeImg, nextImg) {
            var images = gallery.images;
            index = ((index + 1) === images.length) ? 0 : (index + 1); // Update Index

            /**
             * Clean Previous image src since it will become the Next image
             * else when changing it to Next image it won't update
             * its look until the new image has been loaded
             */
            if (isImage(prevImg)) {
                setAttr(prevImg, "srcset", "");
                setAttr(prevImg, "src", "");
            }

            /**
             * Change the Previous image to become the Next image
             */
            var newNextIndex = ((index + 1) === images.length) ? 0 : (index + 1);

            prevImg = tryToggleImageType(prevImg, newNextIndex);

            setSizes(prevImg, images[newNextIndex].sizes);
            setSrcset(prevImg, images[newNextIndex].Srcset);
            setSrc(prevImg, images[newNextIndex].url);
            setAlt(prevImg, images[newNextIndex].alt);
            var positionImageCollection = images[newNextIndex].position;
            var collectionName = images[newNextIndex].collection;
            var id = images[newNextIndex].id;

            if (collectionName && typeof positionImageCollection != "undefined") {
                setPosition(prevImg, positionImageCollection);
                setCollection(prevImg, collectionName);
                setImgId(prevImg, id);
            }

            setFloorPlanClass(true, index, nextImg);

            /**
             * Update images relations
             * Current Next -> New Active
             * Current Active -> New Previous
             * Current Previous -> New Next
             */

            setAttr(nextImg, "class", getAttr(nextImg, "class").replace("next", "active").replace('nhs-u-opacity-0', ''));
            setAttr(activeImg, "class", getAttr(activeImg, "class").replace("active", "previous nhs-u-opacity-0"));
            setAttr(prevImg, "class", getAttr(prevImg, "class").replace("previous", "next"));
            setAttr(prevImg, "class", getAttr(prevImg, "class").replace("active", "next"));

            nextImg.dataset.segmentEvent = "true";
            nextImg.dataset.segmentEventEvent = "Gallery Viewer Opened";
            nextImg.dataset.segmentEventMedia_type = images[index].collection;
            nextImg.dataset.event = "true";
            nextImg.dataset.iscomm = activeImg.dataset.iscomm;
            nextImg.dataset.ga4EventName = 'gallery_detail_pages';
            nextImg.dataset.ga4EventClick_target = 'Gallery Popup Open';

            var segmentEvent = {
              eventType: 'segmentEvent',
              media_type: nextImg.dataset.segmentEventMedia_type,
              image_url: nextImg.src,
              image_sequence: images[index].position + 1,
              image_type: nextImg.dataset.segmentEventMedia_type,
              event: nextImg.dataset.iscomm === "False"
                ? 'Home Image Displayed'
                : 'Community Image Displayed',
            };

            document.body.dispatchEvent &&
              document.body.dispatchEvent(new CustomEvent("trackOnDemandEvent", {
              detail: { data: segmentEvent }
            }));

            onChange(index, images[index]); // Run onChange event
        },

        /**
         * Moves the Gallery to the Previous image
         * 
         * @private
         * @param {Image | HTMLDivElement} prevImg Previous Image
         * @param {Image | HTMLDivElement} activeImg Active Image         
         * @param {Image | HTMLDivElement} nextImg Next Image
         */
        goPrev = function(prevImg, activeImg, nextImg) {
            var images = gallery.images;
            index = index - 1 < 0 ? images.length - 1 : index - 1; // Update Index

            /**
             * Clean Next image src since it will become the Previous image
             * else when changing it to Previous image it won't update
             * its look until the new image has been loaded
             */
            if (isImage(prevImg)) {
                setAttr(nextImg, "srcset", "");
                setAttr(nextImg, "src", "");
            }

            /**
             * Change the Next image to become the Previous image
             */
            var newPrevIndex = index - 1 < 0 ? images.length - 1 : index - 1;

            nextImg = tryToggleImageType(nextImg, newPrevIndex);

            setSizes(nextImg, images[newPrevIndex].sizes);
            setSrcset(nextImg, images[newPrevIndex].Srcset);
            setSrc(nextImg, images[newPrevIndex].url);
            setAlt(nextImg, images[newPrevIndex].alt);
            var positionImageCollection = images[newPrevIndex].position;
            var collectionName = images[newPrevIndex].collection;
            var id = images[newPrevIndex].id;

            if (typeof positionImageCollection != "undefined" && collectionName) {
                setPosition(nextImg, images[newPrevIndex].position);
                setCollection(nextImg, images[newPrevIndex].collection);
                setImgId(nextImg, id);
            }

            setFloorPlanClass(false, index, nextImg);

            /*
             * Update images relations
             * Current Previous -> New Active
             * Current Active ->New Next
             * Current Next -> New Previous
             */
            setAttr(prevImg, "class", getAttr(prevImg, "class").replace("previous", "active").replace('nhs-u-opacity-0', '') );
            setAttr(activeImg, "class", getAttr(activeImg, "class").replace("active", "next nhs-u-opacity-0") );
            setAttr(nextImg, "class", getAttr(nextImg, "class").replace("next", "previous") );
            setAttr(nextImg, "class", getAttr(nextImg, "class").replace("active", "previous"));

            prevImg.dataset.segmentEvent = "true";
            prevImg.dataset.segmentEventEvent = "Gallery Viewer Opened";
            prevImg.dataset.segmentEventMedia_type = images[index].collection;
            prevImg.dataset.event = "true";
            prevImg.dataset.iscomm = activeImg.dataset.iscomm;
            prevImg.dataset.ga4EventName = 'gallery_detail_pages';
            prevImg.dataset.ga4EventClick_target = 'Gallery Popup Open';

            var segmentEvent = {
              eventType: 'segmentEvent',
              media_type: prevImg.dataset.segmentEventMedia_type,
              image_url: prevImg.src,
              image_sequence: images[index].position + 1,
              image_type: prevImg.dataset.segmentEventMedia_type,
              event: prevImg.dataset.iscomm === "False"
                ? 'Home Image Displayed'
                : 'Community Image Displayed',
            };

            document.body.dispatchEvent &&
              document.body.dispatchEvent(new CustomEvent("trackOnDemandEvent", {
              detail: { data: segmentEvent }
            }));

            onChange(index, images[index]); // Run onChange event
        },

        /**
         * Sets the touchId property if this is undefined
         * using the Touch of a TouchEvent and reduces
         * the animation time of the Gallery to the minimum possible value
         * 
         * @private
         * @param {TouchEvent} event TouchEvent         
         */
        registerTouch = function(event) {
            if (!(isUndefined(touchId) && isUndefined(lastX) && touches === 0) || changeRunning) return;
            touches++;
            var touch = getTouch(event);
            touchId = getTouchId(touch);
            lastX = getTouchX(touch);
            setXAnimationTime(0);
        },

        /**
         * Executes a go Function a certain amount of times
         * 
         * @private         
         * @param {Function} goFn Go Function
         * @param {Number} times Times to repeat
         */
        go = function(goFn, times) {
            if (isUndefined(times) || isNaN(times)) {
                times = 1;
            }

            var previous = context.querySelector(".previous");
            var active = context.querySelector(".active");
            var next = context.querySelector(".next");

            goFn(previous, active, next);
            times--;
            if (times) {
                setTimeout(function() {
                        go(goFn, times);
                    },
                    500);
            }
        },

        /**
         * Defines a property to an Object
         * 
         * @private         
         * @param {String} propName Property name
         * @param {Function} getter Getter function
         * @param {Function} setter Setter function
         */
        defineProp = function(propName, getter, setter) {
            Object.defineProperty(gallery,
                propName,
                {
                    get: getter,
                    set: setter
                });
        },

        cleanStyles = function() {
            for (var i = 0; i < arguments.length; i++) {
                removeAttr(arguments[i], "style");
            }
        },
        setCssVar = function(cssVarName, value) {
            document.documentElement.style.setProperty(cssVarName, value);
        };


    var index = 0,        
        touches = 0,
        touchId = getUndefined(),
        changeRunning = !1,
        lastX = getUndefined(),
        onChange = function(){};

    gallery.images = images;

    (function () {

        /*** Events Binding ***/
        var bindEvents = function () {
            
            /*** Controls Events Binding ***/
            var controls = Array.from(context.querySelectorAll(".control"));

            controls.forEach(function(control) {
              addEvent(control, "click", function () {
                /**
                 * If There's any touch hold or a image change running do nothing
                 */
                if (!isUndefined(touchId) || changeRunning) return;
                var previousImg = context.querySelector(".previous"),
                  activeImg = context.querySelector(".active"),
                  nextImg = context.querySelector(".next");

                /**
                 * Change Visual properties in a Request Animation Frame callback
                 * to wait until all the visual properties has been changed to
                 * let the browser perform a paint
                 */
                requestAnimationFrame(function () {
                  removeAttr(previousImg, "style");
                  removeAttr(activeImg, "style");
                  removeAttr(nextImg, "style");
                  if (hasClass(control, "next")) {
                      goNext(previousImg, activeImg, nextImg);
                  } else if (hasClass(control, "previous")) {
                      goPrev(previousImg, activeImg, nextImg);
                  }

                  var newPreviousImg = context.querySelector(".previous");
                  var newNextImg = context.querySelector(".next");

                });

                /**
                 * Block change execution while the animation is being performed
                 * so that the images do not overlap each other
                 */
                changeRunning = true;
                setTimeout(function () {
                  changeRunning = false;
                  activeImg.classList.remove("nhs_floorPlanFitTransitionNext");
                  activeImg.classList.remove("nhs_floorPlanFitTransitionPrev");
                }, 500);

              });
            });

            /*** Touch Events Binding ***/

            var imageElems = context.querySelectorAll("img.active,img.previous,img.next,.o-viewer.active,.o-viewer.previous,.o-viewer.next");

            for (var i = 0; i < imageElems.length; ++i) {
                var img = imageElems[i];

                var imageElements = [img];

                /*** Touch Registration Handler ***/
                addEvent(imageElements, "touchstart", registerTouch, passive);

                /*** Touch Movement Handler ***/
                addEvent(imageElements, "touchmove", function (event) {
                    event.preventDefault();
                    if (changeRunning) return;
                    /**                  
                     * If the "touchmove" event is triggered before the "touchstart"
                     * register the event's touch
                     */
                    if (isUndefined(touchId) || isUndefined(lastX)) return registerTouch(event);

                    var touch = getTouch(event);

                    /**
                     * Check for the touch Id to avoid multitouch issues
                     */
                    if (touchId !== getTouchId(touch)) return;

                    /**
                     * Calculate touch move measure
                     */
                    var newX = getTouchX(touch),
                        diff = lastX - newX,
                        prevImg = context.querySelector(".previous"),
                        activeImg = context.querySelector(".active"),
                        nextImg = context.querySelector(".next"),
                        activeWidth = activeImg.width || activeImg.offsetWidth,
                        prevX = getImgX(prevImg) || activeWidth * -1,
                        activeX = getImgX(activeImg),
                        nextX = getImgX(nextImg) || activeWidth,
                        tDiff = activeX - diff; // Total difference: Total movement of the left image edge

                    lastX = newX; // Overwrite Last X value with the Nex X value

                    /**
                     * If the Total difference is greater the the width of the
                     * active image, using 25px as margin, lock the gallery movement
                     */
                    if (Math.abs(tDiff) > (activeWidth - 25)) return;

                    /**
                     * Perform the follow touch movement, await until the X values of
                     * the images has been updated to let the browser paint the screen                 
                     */
                    requestAnimationFrame(function () {
                        setImgX(prevImg, prevX - diff);
                        setImgX(activeImg, tDiff);
                        setImgX(nextImg, nextX - diff);
                        //addClass(context, "swiping");
                    });

                }, { passive: false });

                /*** Touch End Handler ***/
                addEvent(imageElements, "touchend", function (event) {
                    if (changeRunning) return;
                    touches--;

                    var touch = getTouch(event);

                    /**
                     * If the touch Id of the leaving touch is the
                     * same of the registered touch, continue.
                     * If the touches are greater than 0 do nothing.
                     */
                    if (touchId !== getTouchId(touch) || touches > 0) return;

                    /**
                     * Clean the variables
                     */
                    touchId = getUndefined();
                    lastX = getUndefined();

                    var prevImg = context.querySelector(".previous"),
                        activeImg = context.querySelector(".active"),
                        nextImg = context.querySelector(".next"),
                        activeX = getImgX(activeImg),
                        prevX = getImgX(prevImg),
                        nextX = getImgX(nextImg),
                        activeWidth = activeImg.width || activeImg.offsetWidth;

                    /**
                     * Perform the animation after touch left, but await until the Functions
                     * has been executed to let the browser paint the screen again
                     */
                    requestAnimationFrame(function () {
                        /**
                         * If the X value of the active image is greater than
                         * the eighth part of the full active image width, perform the change
                         * according to the symbol(+/-) of the active image's X value
                         */
                        setCssVar("--active-x", activeX + "px");
                        setCssVar("--previous-x", prevX + "px");
                        setCssVar("--next-x", nextX + "px");

                        if (Math.abs(activeX) > (activeWidth / 8)) {
                            setXAnimationTime(0.5);
                            if (activeX < 0) {
                                setImgX(nextImg, 0);
                                setImgX(activeImg, activeWidth * -1);
                                setAnimationTime(prevImg, "transform", 0);
                                setImgX(prevImg, activeWidth);
                                setTimeout(function () {
                                    goNext(prevImg, activeImg, nextImg);
                                    cleanStyles(prevImg, activeImg, nextImg);
                                }, 500);
                            } else {
                                setImgX(prevImg, 0);
                                setImgX(activeImg, activeWidth);
                                setAnimationTime(nextImg, "transform", 0);
                                setImgX(nextImg, activeWidth * -1);
                                setTimeout(function () {
                                    goPrev(prevImg, activeImg, nextImg);
                                    cleanStyles(prevImg, activeImg, nextImg);
                                }, 500);
                            }
                        } else {
                            setXAnimationTime(0.3);
                            setImgX(nextImg, activeWidth);
                            setImgX(activeImg, 0);
                            setImgX(prevImg, activeWidth * -1);
                            setTimeout(function () {
                                cleanStyles(prevImg, activeImg, nextImg);
                            }, 300);
                        }

                        setCssVar("--active-x", "0%");
                        setCssVar("--previous-x", "-100%");
                        setCssVar("--next-x", "100%");

                    });

                    changeRunning = true;
                    setTimeout(function () {
                        changeRunning = false;
                    }, 500);

                }, passive);
            }
        };

        /*** Gallery Initialization ***/
        (function () {
            var images = gallery.images,
                active = context.querySelector("img"),
                /*** Creation of the Auxiliary images ***/
                previous = document.createElement("img"),
                next = document.createElement("img"),
                currentSrc = getAttr(active, "src");

            var nextIndex;
            var prevIndex;

            /*** Images Set Up ***/
            active.classList.add("active");
            previous.classList.add("previous", "nhs-u-absolute-centered", "nhs-c-wrapper__hero-image-slide--desktop", "nhs-u-opacity-0");
            previous.setAttribute("data-full-image-viewer-opener", "true");
            next.classList.add("next", "nhs-u-absolute-centered", "nhs-c-wrapper__hero-image-slide--desktop", "nhs-u-opacity-0");
            next.setAttribute("data-full-image-viewer-opener", "true");

            /*** Index initialization is based on the image already loaded ***/
            for (var i = 0; i < images.length; ++i) {
                if (images[i].url === currentSrc) {
                    index = i;
                    break;
                }
            }

            if (images.length > 2) {
                nextIndex = index + 1 === images.length ? 0 : index + 1;
                prevIndex = index - 1 < 0 ? images.length - 1 : index - 1;
            } else {
                nextIndex = images.length === 1 ? 0 : 1;
                prevIndex = images.length === 1 ? 0 : 1;
            }

            /*** Images DOM Insertion ***/
            setSizes(next, images[nextIndex].sizes);
            setSrcset(next, images[nextIndex].Srcset);
            setSrc(next, images[nextIndex].url);
            setAlt(next, images[nextIndex].alt);
            var collectionNameNext = images[nextIndex].collection;
            var positionImageCollectionNext = images[nextIndex].position;
            var idImageNext = images[nextIndex].id;

            if (collectionNameNext && typeof positionImageCollectionNext !== "undefined") {
                setPosition(next, positionImageCollectionNext);
                setCollection(next, collectionNameNext);
                setImgId(next, idImageNext);
            }

            setSizes(previous, images[prevIndex].sizes);
            setSrcset(previous, images[prevIndex].Srcset);
            setSrc(previous, images[prevIndex].url);
            setAlt(previous, images[prevIndex].alt);
            var collectionNamePrev = images[prevIndex].collection;
            var positionImageCollectionPrev = images[prevIndex].position;
            var idImagePrev = images[prevIndex].id;

            if (collectionNamePrev && typeof positionImageCollectionPrev !== "undefined") {
                setImgId(previous, idImagePrev);
                setCollection(previous, images[prevIndex].collection);
                setPosition(previous, positionImageCollectionPrev);
            }

            insertAt(previous, "beforebegin", active);
            insertAt(next, "afterend", active);

            bindEvents();

            if (images.length > 1) {
            var segmentEvent = {
              eventType: 'segmentEvent',
              media_type: active.dataset.segmentEventMedia_type,
              image_url: active.src, 
              image_sequence: 1,
              image_type: active.dataset.segmentEventMedia_type,
              event: active.dataset.iscomm === "False"
                ? 'Home Image Displayed'
                : 'Community Image Displayed',
            };

            document.body.dispatchEvent &&
              document.body.dispatchEvent(new CustomEvent("trackOnDemandEvent", {
              detail: { data: segmentEvent }
            }));
          }

        })();
    })();

    /**
     * Goes to the next image
     * 
     * @public
     * @readonly          
     * @param {Number} times Times to repeat
     */
    defineProp("goNext", function () {
        return function (times) {
            go(goNext, times);
        };
    });

    /**
     * Goes to the previous Image
     * 
     * @public
     * @readonly
     * @param {Number} times Times to repeat
     */
    defineProp("goPrev", function () {
        return function (times) {
            go(goPrev, times);
        };
    });

    /**
     * Gets the index of the Gallery
     * 
     * @public
     * @readonly
     */
    defineProp("index", function () {
        return index;
    });

    /**
     * Function to trigger each time the Gallery changes
     * 
     * @public
     */
    defineProp("onChange",
        function () {
            return onChange;
        },
        function (value) {
            if (value instanceof Function) {
                onChange = value;
            }
        }
    );
};

(function(){
    "use strict";

    if ("function" === typeof define && define.amd) {
        // If supports for AMD is available return the value to the AMD Loader
        // and to the global (window) object in case any JS module is expecting
        // the lazyLoad to exists on the window object.
        define('gallery',[], function () {
            return galleryInit;
        });
    } else if ("object" === typeof exports) {
        // If supports for Common JS is available export the module
        // and pass is value to the global (window) object in case non Common JS code 
        // is expected to work with this lazyLoad.
        module.exports = galleryInit;
    } else {
        // If not support for AMD or Common JS is available register the module in the global scope.
        
        if ("undefined" === typeof NHS || null === NHS) {
            NHS = {};
        }
        if ("undefined" === typeof NHS.Scripts || null === NHS.Scripts) {
            NHS.Scripts = {};
        }

        NHS.Scripts.Gallery = galleryInit;
    }


}());
